const RoadmapService = () => {
    /**
     * The roadmap url.
     */
    const url = () => {
        return 'https://www.notion.so/Roadmap-2495f2fae8e942b18693523b30434d64';
    };

    return {
        url
    };
};

export default RoadmapService();
